import { ColorV2 } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import React from "react";
import { useTranslation } from "react-i18next";
import "react-tooltip/dist/react-tooltip.css";
import { Key, NumberPadContainer, Text } from "./numberPad.styled";

const NUMBER_PAD_VALUES = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

export type NumberPadInput =
  | { type: "digit"; value: string }
  | { type: "clear" };

type NumberPadProps = {
  checkedIn?: boolean;
  keyShouldBeDisabled: boolean;
  onNumberChange: (input: NumberPadInput) => void;
  onClickStampKey: () => void;
};

export const NumberPad = React.memo(
  ({
    checkedIn,
    keyShouldBeDisabled,
    onNumberChange,
    onClickStampKey,
  }: NumberPadProps) => {
    const { t } = useTranslation();
    const digitKeyBackground = keyShouldBeDisabled ? ColorV2.Blue6 : null;

    return (
      <>
        <NumberPadContainer>
          {NUMBER_PAD_VALUES.map((value) => (
            <Key
              key={value}
              backgroundColor={digitKeyBackground}
              onClick={() => {
                if (!keyShouldBeDisabled) {
                  onNumberChange({ type: "digit", value });
                }
              }}
            >
              <Text
                fontFamily={FontFamily.MontserratSemiBold}
                fontSize={FontSize.H3}
                color={ColorV2.White}
              >
                {value}
              </Text>
            </Key>
          ))}
          <Key
            backgroundColor={ColorV2.NegativeRed}
            onClick={() => onNumberChange({ type: "clear" })}
          >
            <Text
              fontFamily={FontFamily.MontserratSemiBold}
              fontSize={FontSize.H3}
              color={ColorV2.White}
            >
              {"C"}
            </Text>
          </Key>
          <Key
            backgroundColor={digitKeyBackground}
            onClick={() => {
              if (!keyShouldBeDisabled) {
                onNumberChange({ type: "digit", value: "0" });
              }
            }}
          >
            <Text
              fontFamily={FontFamily.MontserratSemiBold}
              fontSize={FontSize.H3}
              color={ColorV2.White}
            >
              {"0"}
            </Text>
          </Key>
          <Key
            backgroundColor={
              !keyShouldBeDisabled ? ColorV2.Blue6 : ColorV2.PositiveGreen
            }
            onClick={() => {
              if (keyShouldBeDisabled) onClickStampKey();
            }}
          >
            <Text
              fontFamily={FontFamily.MontserratSemiBold}
              fontSize={FontSize.H3}
              color={ColorV2.White}
            >
              {!checkedIn ? t("StampClock.In") : t("StampClock.Out")}
            </Text>
          </Key>
        </NumberPadContainer>
      </>
    );
  },
);
